import { type FC } from "react";
import { Trans, useTranslation as useTranslation } from "react-i18next";
import { resolveUrl } from "~/utils/url/urlResolver";
import { Alert } from "~/common/mui/Alert/Alert";

interface Props {
  close: () => void;
}

const ResetSuccessContent: FC<Props> = ({ close }) => {
  const { t } = useTranslation();

  return (
    <>
      <Alert severity="info" className="mb-3">
        {t("popup.passwordSuccess.info")}
      </Alert>
      <div className="mb-2"> {t("popup.passwordSuccess.question")}</div>
      <ul className="ml-4 pl-0 mb-2">
        <li> {t("popup.passwordSuccess.bullet1")}</li>
        <li>{t("popup.passwordSuccess.bullet2")}</li>
        <li>
          <Trans
            i18nKey="popup.passwordSuccess.bullet3"
            components={{ linkElement: <a href={resolveUrl("/faq")} target={"_blank"} /> }}
          />
        </li>
      </ul>
    </>
  );
};
export default ResetSuccessContent;
